import Vue from 'vue'
import Vuex from 'vuex'
// import axios from 'axios' // remove comment if yu needed
import Crud from '../crud'
const model = (payload) => ({
  // columns
  id: payload.id,
  sku: payload.sku,
  description: payload.description,
  tax: payload.tax,
  price_buy: payload.price_buy,
  unit_of_measurement: payload.unit_of_measurement,
  sat_code: payload.sat_code
})
var crud = new Crud('Supplies', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  supplies: [],
  isDescriptionValid: true
}

const mutations = {
  ...crud.mutations,
  SET_DESCRIPTION_VALID (state, payload) {
    const description = state.supplies.findIndex(supplie => supplie.description === payload)
    state.isDescriptionValid = description < 0
  }
}

const actions = {
  ...crud.actions,
  searchDescription ({ commit }, payload) {
    commit('SET_DESCRIPTION_VALID', payload)
  }
}

const getters = {
  ...crud.getters,
  supplies: state => state.supplies,
  isDescriptionValid: state => state.isDescriptionValid
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
